export class HolidayModel {
  fromDate: Date;
  toDate: Date;
  description: String;
  projectId: number;
  category: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/holiday/holiday.model.ts